<template>
	<div
		class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
		id="page-login"
	>
		<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
			<vx-card>
				<div
					slot="no-body"
					class="full-page-bg-color"
				>
					<div class="vx-row no-gutter justify-center items-center">

						<div class="vx-col hidden lg:block lg:w-1/2">
							<img
								src="@/assets/images/pages/login.png"
								alt="login"
								class="mx-auto"
							>
						</div>

						<div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
							<vs-alert
								active="true"
								color="success"
								v-if="message"
							>
								<span>
									{{ message }}
								</span>
							</vs-alert>
							<div class="p-8 login-tabs-container mb-10">

								<div class="vx-card__title mb-4">
									<h4 class="mb-4">Bejelentkezés</h4>
								</div>

								<div class="mt-10">
									<vs-input
										name="email"
										icon-no-border
										icon="icon icon-user"
										icon-pack="feather"
										label-placeholder="E-mail"
										v-model="email"
										class="w-full"
										v-on:keyup.enter="login"
									/>

									<vs-input
										type="password"
										name="password"
										icon-no-border
										icon="icon icon-lock"
										icon-pack="feather"
										label-placeholder="Jelszó"
										v-model="password"
										class="w-full mt-6"
										v-on:keyup.enter="login"
									/>

									<div class="flex flex-wrap justify-between my-5">
										<vs-checkbox
											v-model="checkbox_remember_me"
											class="mb-3"
										>Emlékezz rám</vs-checkbox>
										<router-link to="elfelejtett-jelszo">Elfelejtett jelszó</router-link>
									</div>
									<vs-button
										class="float-right"
										@click="login()"
									>Bejelentkezés</vs-button>

								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			email: "",
			password: "",
			checkbox_remember_me: false,
			message: this.$route.params.message,
		}
	},
	methods: {
		login() {
			// Loading
			this.$vs.loading()

			const payload = {
				checkbox_remember_me: this.checkbox_remember_me,
				userDetails: {
					email: this.email,
					password: this.password
				}
			}

			this.$store.dispatch('auth/login', payload)
				.then(() => { this.$vs.loading.close() })
				.catch(error => {
					this.$vs.loading.close()
					console.log(error.response);
					this.$vs.notify({
						title: 'Hiba',
						text: error.response.data.message ? error.response.data.message : (error.response.data.email ? error.response.data.email[0] : (error.response.data.password[0] ? error.response.data.password[0] : '')),
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
				})
		},
	}
}
</script>

<style lang="scss">
#page-login {
	.social-login-buttons {
		.bg-facebook {
			background-color: #1551b1;
		}
		.bg-twitter {
			background-color: #00aaff;
		}
		.bg-google {
			background-color: #4285f4;
		}
		.bg-github {
			background-color: #333;
		}
	}
}
</style>
